import { mapActions, mapGetters, mapMutations } from "vuex";
import { VueSlideToggle } from "vue-slide-toggle";

import chatRooms from "../../components/course-sidebar/chat-rooms/index.vue";
import coursesModule from "../../components/course-module/index.vue";
import courseGraduateWork from "../../components/course-graduate-work/index.vue";
import datepickerEvents from "../../components/course-sidebar/datepicker-events/index.vue";
import skills from "../../components/course-sidebar/skills/index.vue";
import recommendations from "../../components/course-sidebar/recommendations/index.vue";
import topStudents from "../../components/course-sidebar/top-students/index.vue";
import allStudents from "../../components/course-sidebar/all-students/index.vue";
import statistic from "../../components/course-statistic/index.vue";
import trailer from "../../components/video-trailer/index.vue";
import headerBladeFullCenter from "../../components/course-headers/blade-full-center/index.vue";
import headerBladeFullLeft from "../../components/course-headers/blade-full-left/index.vue";
import headerBladeSeparated from "../../components/course-headers/blade-separated/index.vue";
import headerBladeWithSidebar from "../../components/course-headers/blade-with-sidebar/index.vue";
import headerBladeWithoutHeader from "../../components/course-headers/blade-without-header/index.vue";
import fixedModule from "../../components/course-fixed-module/index.vue";
import downloadCertificate from "../../components/download-certificate-button/index.vue";
import StarRating from "vue-star-rating";

import VideoPlayer from "@/components/video-player/index.vue";
// import donate from "@/components/features/donate/index.vue";
import freeAccess from "@/components/features/free-access/index.vue";
import courseBanner from "@/components/features/course-banner/index.vue";
import marathonBanner from "@/components/features/marathon-banner/index.vue";
import widgetHost from "@/components/features/widget-host/index.vue";
import courseLearnMoreForm from "../../components/course-learn-more-form/index.vue";

import courseLoader from '@/modules/courses/components/course-loader/index.vue'
import coursesLoader from '@/modules/courses/components/courses-loader/index.vue'

import { seo } from "@/mixins/seo";

import ModalPointA from "@/components/modals/ModalPointA";
import ModalPointB from "@/components/modals/ModalPointB";
import { $http } from "@/utils/https";

export default {
	name		: "course-dashboard",
	mixins		: [seo],
	data() {
		return {
			open            : false,
			readMore        : true,
			activeItem      : "overview",
			isMobile        : false,
			showTrailer     : false,
			showAllStudents : false,
			certPointAModalVisible: false,
			certPointBModalVisible: false,
			//isLoading		: true
		};
	},
	components	: {
		//donate,
		"free-access": freeAccess,
		'course-loader': courseLoader,
		'courses-loader': coursesLoader,
		"course-banner": courseBanner,
		"marathon-banner": marathonBanner,
		"widget-host": widgetHost,
		VideoPlayer,
		coursesModule,
		VueSlideToggle,
		skills,
		recommendations,
		topStudents,
		allStudents,
		statistic,
		fixedModule,
		trailer,
		chatRooms,
		"header-full-center": headerBladeFullCenter,
		"header-full-left": headerBladeFullLeft,
		"header-separated": headerBladeSeparated,
		"header-with-sidebar": headerBladeWithSidebar,
		"header-without-header": headerBladeWithoutHeader,
		datepickerEvents,
		courseGraduateWork,
		StarRating,
		"download-certificate-button": downloadCertificate,
		"course-learn-more-form": courseLearnMoreForm,
		ModalPointA,
		ModalPointB,
	},
	watch		: {
		"$route.path"() {
			//return;
			
			if(false){
				this.fetchData({
					slug: this.$route.params.item
				})
				.then(() => {
					Object.assign(this.seo, this.currentItem.seo.data);
					
					this.$emit("updateHead");
				});
				
				this.getComponents({
					slug: this.$route.params.item
				});
			}
		},
		currentItem: {
			immediate: true,
			handler (v) {
				if (!v) return;

				// SEO
				try {
					Object.assign(this.seo, v.seo.data || {});
				} catch (e) {}

				if (v.name) {
					this.seo.title = v.name + ' | Genius Space';
				}

				this.$emit("updateHead");

				this.getComponents({
					slug: this.$route.params.item
				});
			}
		}
	},
	created() {
		this.$bus.$on("event-open-trailer", () => {
			this.showTrailer = true;
		});
		
		if (this.$route.query.active) {
			this.setActive("lessons");
		}
	},
	computed	: {
		...mapGetters({
			currentItem : "courses/currentItem",
			isLoading   : "courses/isLoading",
		}),
		courseInfo() {
			if (!this.currentItem) return "";
			
			let countLessons = 0;
			
			let duration = this.currentItem.duration;
			
			this.currentItem.modules.data.forEach((el) => {
				countLessons = countLessons + el.lessons.data.length;
			});
			
			return {
				countLesson: countLessons,
				durationOur: Math.trunc(duration / 360),
				durationMin: duration % 360,
			};
		},
		videoInfo() {
			return {
				src     : this.currentItem.trailerUrl,
				provider: this.currentItem.trailerProvider,
				title   : this.currentItem.name,
			};
		},
		userCourse() {
			if (!this.currentItem) {
				return null;
			}
			
			if (!this.currentItem.userCourse) {
				return null;
			}
			
			return this.currentItem.userCourse.data;
		},
		certPointAClosedCount() {
			const uc = this.userCourse;
			
			if (!uc) {
				return 0;
			}
			
			const raw =
				uc.pointAClosedCount != null
					? uc.pointAClosedCount
					: uc.point_a_closed_count;
			
			const n = Number(raw);
			
			return Number.isFinite(n) ? n : 0;
		},
	},
	mounted() {
		console.log('course-dashboard');
		
		this.onResize();
		
		window.addEventListener("resize", this.onResize, { passive: true });
		
		//alert('course');
	},
	methods		: {
		...mapActions({
			//fetchData           : "courses/GET_COURSE_ITEM",
			getComponents       : "courses/GET_COMPONENTS",
			setLessonFavourite  : "coursesLesson/SET_LESSON_FAVOURITE",
			setLessonUnfavourite: "coursesLesson/SET_LESSON_UNFAVOURITE",
			getList             : "courses/GET_LIST",
			fetchCourseItem     : "courses/GET_COURSE_ITEM",
		}),
		...mapMutations({
			setContent: `courses/SET_ITEM`,
		}),
		closePopup() {
			this.showTrailer = false;
		},
		isActive(menuItem) {
			return this.activeItem === menuItem;
		},
		setActive(menuItem) {
			this.activeItem = menuItem;
			
			this.$router.replace({ query: null });
		},
		onResize() {
			this.isMobile = window.innerWidth < 950;
		},
		formattedTime(time, key = "default") {
			const hours = Math.floor(time / 60);
			const minutes = time % 60;
			
			if (key === "default") {
				return `${hours < 10 ? "0" + hours : hours} ${this.$t("shortHour")} ${
					minutes < 10 ? "0" + minutes : minutes
				} ${this.$t("shortMinutes")}`;
			} else {
				return `${hours < 10 ? "0" + hours : hours}:${
					minutes < 10 ? "0" + minutes : minutes
				}:00`;
			}
		},
		declensionWord(count) {
			let titles = [
				this.$t("lessonWord1"),
				this.$t("lessonWord2"),
				this.$t("lessonWord3"),
			];
			
			let cases = [2, 0, 1, 1, 1, 2];
			
			return titles[
				count % 100 > 4 && count % 100 < 20
					? 2
					: cases[count % 10 < 5 ? count % 10 : 5]
			];
		},
		async onCertOpenPointA() {
			if (!this.currentItem || !this.currentItem.slug) {
				return;
			}
			
			try {
				await this.$store.dispatch("pointAB/GET_MY_SUBMISSIONS", {
					courseSlug: this.currentItem.slug,
				});
			} catch (e) {
				console.error(e);
				
				return;
			}
			
			this.certPointAModalVisible = true;
		},
		async onCertOpenPointB() {
			if (!this.currentItem || !this.currentItem.slug) {
				return;
			}
			
			try {
				await this.$store.dispatch("pointAB/GET_MY_SUBMISSIONS", {
					courseSlug: this.currentItem.slug,
				});
			} catch (e) {
				console.error(e);
				
				return;
			}
			
			this.certPointBModalVisible = true;
		},
		async onCertPointACompleted() {
			this.certPointAModalVisible = false;
			
			await this.fetchCourseItem({
				slug: this.$route.params.item,
			});
			
			try {
				await this.$store.dispatch("pointAB/GET_MY_SUBMISSIONS", {
					courseSlug: this.currentItem.slug,
				});
			} catch (e) {
				console.error(e);
			}
			
			this.certPointBModalVisible = true;
		},
		async onCertPointBCompleted() {
			this.certPointBModalVisible = false;
			
			await this.fetchCourseItem({
				slug: this.$route.params.item,
			});
			
			if (!this.currentItem || !this.currentItem.slug) {
				return;
			}
			
			try {
				const res = await $http.get(
					`${process.env.VUE_APP_ROOT_COURSE}my/courses/${this.currentItem.slug}/certificate/pdf`
				);
				
				const link = res.data && res.data.link ? res.data.link : null;
				
				if (link) {
					window.open(link, "_blank");
				}
			} catch (e) {
				console.error(e);
			}
		},
		changeShowAllStudents() {
			// if( !this.showAllStudents ){
			//   this.changeShowProfileTooltip(true);
			// }else{
			//   this.changeShowProfileTooltip(false);
			// }
			this.showAllStudents = !this.showAllStudents;
		},
		async onClickFavorite(item) {
			const storedPin = item.userCourse.data.pin;
			
			item.userCourse.data.pin = !item.userCourse.data.pin;
			
			try {
				if (item.userCourse.data.pin) {
					try {
						await this.setLessonFavourite({
							slug: item.slug,
						});
					} catch (err) {
						item.userCourse.data.pin = storedPin;
						console.log("error");
						throw err;
					}
				}
				
				if (!item.userCourse.data.pin) {
					try {
						await this.setLessonUnfavourite({
							slug: item.slug,
						});
					} catch (err) {
						item.userCourse.data.pin = storedPin;
						console.log("error");
						throw err;
					}
				}
				
				await this.getList({ isResetList: false, isSkip: true });
			} catch (error) {
				console.error("error[pin]", error);
			}
		},
	},
};
